'use client';

import * as React from 'react';
import { useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { Device } from 'store/reducers/deviceReducers';

type SortOrder = 'asc' | 'desc';

interface TableProps {
  rows?: Device[];
}

function CustomersTable({ rows = [] }: TableProps): React.JSX.Element {
  const [sortByGroup, setSortByGroup] = useState(false);
  const [sortOrder, setSortOrder] = useState<SortOrder>('asc');

  const handleSortGroup = () => {
    const isAsc = sortByGroup && sortOrder === 'asc';
    setSortOrder(isAsc ? 'desc' : 'asc');
    setSortByGroup(true);
  };

  const sortedRows = useMemo(() => {
    if (!sortByGroup) {
      return rows;
    }

    return [...rows].sort((a, b) => {
      const comparison = a.group.name.localeCompare(b.group.name);
      return sortOrder === 'asc' ? comparison : -comparison;
    });
  }, [rows, sortByGroup, sortOrder]);

  return (
    <Card>
      <Box sx={{ overflowX: 'auto' }}>
        <Table sx={{ minWidth: '800px' }}>
          <TableHead>
            <TableRow>
              <TableCell>Serial Number</TableCell>
              <TableCell>Version</TableCell>
              <TableCell>Target</TableCell>
              <TableCell sortDirection={sortByGroup ? sortOrder : false}>
                <TableSortLabel
                  active={sortByGroup}
                  direction={sortByGroup ? sortOrder : 'asc'}
                  onClick={handleSortGroup}
                >
                  Group
                </TableSortLabel>
              </TableCell>
              <TableCell>latitude</TableCell>
              <TableCell>longitude</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedRows.map((row) => {
              const publicUrl = `/devices/${row.serial}`;
              return (
                <TableRow hover key={row.serial}>
                  <TableCell>
                    <a href={publicUrl} rel='noopener noreferrer'>
                      {row.serial}
                    </a>
                  </TableCell>
                  <TableCell>{row.version || 'v3'}</TableCell>
                  <TableCell>{row.target.name}</TableCell>
                  <TableCell>{row.group.name}</TableCell>
                  <TableCell>{row.target.latitude}</TableCell>
                  <TableCell>{row.target.longitude}</TableCell>
                  <TableCell>
                    <Chip
                      label={row.is_active ? 'Active' : 'Inactive'}
                      color={row.is_active ? 'success' : 'default'}
                      size='small'
                      sx={{ fontWeight: 'bold' }}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
      <Divider />
    </Card>
  );
}

export default CustomersTable;
